import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '../../symbols';
import { format } from '@/@core/utils/string';
import { buildFormDate } from '@/@core/utils/form';
let ApplyTrialApi = class ApplyTrialApi {
    constructor(http, urls) {
        this.http = http;
        this.urls = urls;
        this.getSafeDetail = () => {
            const url = this.urls.getSafeDetail;
            return this.http.get({
                url,
            });
        };
        this.putIpLimitation = (params) => {
            const url = this.urls.putIpLimitation;
            return this.http.put({
                url,
                data: params,
            });
        };
        this.putNoticeLimitation = (noticeLimitation) => {
            const url = this.urls.putNoticeLimitation;
            return this.http.put({
                url,
                data: {
                    notice_limitation: noticeLimitation,
                },
            });
        };
        /**
         * 活动推广列表查询
         */
        this.getActivityPromotionPagination = (params) => {
            const url = this.urls.getActivityPromotionPagination;
            return this.http.get({
                url,
                params,
            });
        };
        /**
         * 新增活动推广
         */
        this.postActivityPromotion = (params) => {
            const url = this.urls.postActivityPromotion;
            return this.http.post({
                url,
                data: params,
            });
        };
        /**
         * 编辑活动推广
         */
        this.putActivityPromotion = (params) => {
            const url = this.urls.putActivityPromotion;
            return this.http.put({
                url,
                data: params,
            });
        };
        /**
         * 查询详情
         */
        this.getActivityPromotion = (id) => {
            const url = format(this.urls.getActivityPromotion, { id });
            return this.http.get({
                url,
            });
        };
        /**
         * 产品查询
         */
        this.getActivityPromotionProductPackageKey = () => {
            const url = this.urls.getActivityPromotionProductPackageKey;
            return this.http.get({
                url,
            });
        };
        /**
         * 活动链接 通用启用
         */
        this.patchActivityPromotionEnabled = (params) => {
            const url = format(this.urls.patchActivityPromotionEnabled, {
                id: params.id,
                enabled: params.enabled,
            });
            return this.http.patch({
                url,
            });
        };
        /**
          * 同步市场活动
          */
        this.postSyncCampaigns = () => {
            const url = this.urls.postSyncCampaigns;
            return this.http.post({
                url,
            });
        };
        /**
         * 上传背景
         */
        this.postActivityPromotionBackground = (params) => {
            const url = format(this.urls.postActivityPromotionBackground, { id: params.id });
            return this.http.post({
                url,
                data: buildFormDate({
                    background: params.background,
                }),
            });
        };
    }
};
ApplyTrialApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.BoHttp)),
    __param(1, inject(Symbols.ApplyTrialUrls)),
    __metadata("design:paramtypes", [Object, Object])
], ApplyTrialApi);
export { ApplyTrialApi };
